import { createStyles, LinearProgress, Theme, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withSnackbar, WithSnackbarProps } from "notistack";
import React, { Component } from "react";
import { FileWithPreview } from "react-dropzone";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../..";
import { ApiResponse } from "../../api/CustomFetch";
import { endpoints } from "../../api/rtk/CandidateApi";
import { NewEntityId } from "../../data/constants";
import { AddCandidateEdiIdsViewModel } from "../../model/AddCandidateEdiIdsViewModel";
import { routesPaths } from "../../Routes";
import { navigateTo } from "../../utils/Navigation";
import TranslatedMessage from "../translations/TranslatedMessage";
import CandidateGrid from "./CandidateGrid";
import ImportEdiIdsDialog from "./ImportEdiIdsDialog";

const mapStateToProps = (state: ApplicationState) => {
  return {
    candidatesState: endpoints.getCandidates.select()(state),
  };
};
const mapDispatchToProps = {
  getCandidates: endpoints.getCandidates.initiate,
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type CandidateListProps = ConnectedProps<typeof connector> & RouteComponentProps & WithSnackbarProps;

type CandidateListState = {
  isUploadEdiIdsDialogOpen: boolean;
};

const styles = ({ spacing }: Theme) =>
  createStyles({
    button: { margin: spacing(1) },
    icon: { marginRight: spacing(1) },
  });

class CandidateList extends Component<CandidateListProps, CandidateListState> {
  constructor(props: CandidateListProps) {
    super(props);
    this.state = {
      isUploadEdiIdsDialogOpen: false,
    };
  }

  private handleUploadEdiIdsDialogClose = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        isUploadEdiIdsDialogOpen: false,
      };
    });
  };

  private handleUploadEdiIdsButtonClick = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        isUploadEdiIdsDialogOpen: true,
      };
    });
  };

  private handleUploadEdiIdsError = () => {
    this.props.enqueueSnackbar(<TranslatedMessage id="common.uploadError" />);
  };

  private handleUploadEdiIdsSuccess = (_: FileWithPreview, response: ApiResponse<AddCandidateEdiIdsViewModel>) => {
    const { updatedCandidatesCount, recordsCount: totalCandidatesCount } = response.data;
    this.props.enqueueSnackbar(
      <>
        <TranslatedMessage id="candidate.ediIdsDialog.uploadSuccess" />{" "}
        {`${updatedCandidatesCount}/${totalCandidatesCount}`}
      </>
    );
  };

  public componentDidMount() {
    this.props.getCandidates();
  }

  public render() {
    return (
      <>
        <Typography variant="h5">
          <TranslatedMessage id="candidate.header" />
        </Typography>
        {this.renderCandidates()}
      </>
    );
  }

  private renderCandidates(): JSX.Element {
    const { isLoading, data: candidates } = this.props.candidatesState;

    if (isLoading) {
      return <LinearProgress variant="query" />;
    }

    if (candidates === undefined) {
      return <></>;
    }

    return (
      <>
        <CandidateGrid
          onUploadEdiIdsButtonClick={this.handleUploadEdiIdsButtonClick}
          candidates={candidates}
          onCandidateClick={this.navigateToCandidate}
          onAddClick={() => this.navigateToCandidate(NewEntityId)}
        />
        <ImportEdiIdsDialog
          isOpen={this.state.isUploadEdiIdsDialogOpen}
          onClose={this.handleUploadEdiIdsDialogClose}
          onFileUploaded={this.handleUploadEdiIdsSuccess}
          onUploadError={this.handleUploadEdiIdsError}
        />
      </>
    );
  }

  private navigateToCandidate = (candidateId: string) => {
    navigateTo(routesPaths.candidate(candidateId), this.props.history);
  };
}

export default withSnackbar(withStyles(styles)(connector(CandidateList)));
